import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material.module';
import { BinaryInputComponent } from './components/binary-input/binary-input.component';
import { BooleanInputComponent } from './components/boolean-input/boolean-input.component';
import { DateInputComponent } from './components/date-input/date-input.component';
import { EntityReferenceInputComponent } from './components/entity-reference-input/entity-reference-input.component';
import { FormValidationErrorsDialogComponent } from './components/form-validation-errors-dialog/form-validation-errors-dialog.component';
import { GrocyBasicsInputComponent } from './components/grocy-basics-input/grocy-basics-input.component';
import { GrocyQuantityUnitInputComponent } from './components/grocy-quantity-unit-input/grocy-quantity-unit-input.component';
import { MonthsInputComponent } from './components/months-input/months-input.component';
import { MultiValueFieldComponent } from './components/multi-value-field/multi-value-field.component';
import { NumberInputComponent } from './components/number-input/number-input.component';
import { OpenFormValidationErrorsDialogComponent } from './components/open-form-validation-errors-dialog/open-form-validation-errors-dialog.component';
import { QuantityUnitInputComponent } from './components/quantity-unit-input/quantity-unit-input.component';
import { TextInputComponent } from './components/text-input/text-input.component';

@NgModule({
  declarations: [
    BinaryInputComponent,
    BooleanInputComponent,
    DateInputComponent,
    EntityReferenceInputComponent,
    FormValidationErrorsDialogComponent,
    GrocyBasicsInputComponent,
    GrocyQuantityUnitInputComponent,
    MonthsInputComponent,
    MultiValueFieldComponent,
    NumberInputComponent,
    OpenFormValidationErrorsDialogComponent,
    QuantityUnitInputComponent,
    TextInputComponent,
  ],
  imports: [CommonModule, FormsModule, MaterialModule, ReactiveFormsModule, RouterModule],
  exports: [
    BinaryInputComponent,
    BooleanInputComponent,
    DateInputComponent,
    EntityReferenceInputComponent,
    FormValidationErrorsDialogComponent,
    GrocyBasicsInputComponent,
    GrocyQuantityUnitInputComponent,
    MonthsInputComponent,
    MultiValueFieldComponent,
    NumberInputComponent,
    OpenFormValidationErrorsDialogComponent,
    QuantityUnitInputComponent,
    TextInputComponent,
  ],
})
export class AppFormsModule {}
